import { Button, Col, Row } from 'react-bootstrap';
import { CountryFlag } from '@/shared/components/export';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { NewsEvent } from '@/modules/calendar/model/calendar/news-event';
import { useWidgetNavigate } from '@/core/widgets/export';
import { selectApi } from '@/modules/calendar/api';
import useDataReleaseHistory from '@/modules/calendar/hooks/use-data-release-history';
import DataReleaseHistoryChart from '@/modules/calendar/components/data/data-release-history-chart';

function DataReleaseChart({ dataReleaseId }: { dataReleaseId: number }) {
  const { events, selectedRelease } = useDataReleaseHistory(dataReleaseId);

  if (!selectedRelease) return <></>;

  return <DataReleaseHistoryChart events={events} selectedRelease={selectedRelease} />;
}

export default function DeepDiveGraphList() {
  const [events, setEvents] = useState<NewsEvent[]>([]);
  const navigate = useWidgetNavigate();

  useEffect(() => {
    selectApi
      .getCalendar(dayjs().startOf('day').valueOf(), dayjs().endOf('day').valueOf())
      .then(value => setEvents(value));
  }, []);

  return (
    <>
      <Row className={'mt-2'}>
        {events
          .filter(event => event.dataReleaseId)
          .map(event => (
            <Col md={6} className={'mb-3'}>
              <h3 className={'mb-2 d-flex align-items-center '}>
                <span className={'border-0 rounded-2 border me-1'}>
                  <CountryFlag country={event.country} width={32} />
                </span>
                <span>{event.title}</span>
                <span className={'ms-auto'}>
                  <Button
                    variant={'tertiary'}
                    size={'sm'}
                    onClick={() => navigate(`/event/${event.id}`)}
                  >
                    View
                  </Button>
                </span>
              </h3>
              <div className={'mb-2'}>{dayjs(event.date).format('MMMM D, YYYY, h:mm a')}</div>

              {event.dataReleaseId && <DataReleaseChart dataReleaseId={event.dataReleaseId} />}
            </Col>
          ))}
      </Row>
    </>
  );
}
